"use client";

// French copy of components/customerTestimonials (FR-1). The quotes are
// translated from English reviews, so every card says so.

import React from "react";
import {
  StyledSection,
  ReviewStar,
} from "../customerTestimonials/customerTestimonials.styles";
import { ITestimonial } from "../customerTestimonials/customerTestimonials.comp";


interface ICustomerTestimonialsEsProps {
  title?: string;
  eyebrow?: string;
  testimonials: ITestimonial[];
  reviewsUrl: string;
}

const VerifiedBadge = ({ size = 12 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M12 2L4 5v6c0 5 3.5 9.5 8 11 4.5-1.5 8-6 8-11V5l-8-3z"
      fill="url(#cn-verified-grad)"
    />
    <path
      d="M9 12l2 2 4-4"
      stroke="#fff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const GradientDefs = () => (
  <svg
    width="0"
    height="0"
    style={{ position: "absolute", overflow: "hidden" }}
    aria-hidden="true"
  >
    <defs>
      <linearGradient id="cn-verified-grad" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#5b5bff" />
        <stop offset="50%" stopColor="#a66cd9" />
        <stop offset="100%" stopColor="#f58a8a" />
      </linearGradient>
    </defs>
  </svg>
);

const StarRow = ({ count = 5 }: { count?: number }) => (
  <div className="stars" aria-label={`Noté ${count} sur 5 étoiles`}>
    {Array.from({ length: count }).map((_, i) => (
      <ReviewStar key={i} aria-hidden="true" />
    ))}
  </div>
);

export const CustomerTestimonialsFr = ({
  title = "De vrais avis. De vrais clients.",
  eyebrow = "Apprécié par nos clients",
  testimonials,
  reviewsUrl,
}: ICustomerTestimonialsEsProps) => {
  if (!testimonials.length) return null;

  const [featured, ...rest] = testimonials;

  return (
    <StyledSection>
      <GradientDefs />
      <div className="inner">
        <header className="head">
          <span className="eyebrow">{eyebrow}</span>
          <h2>{title}</h2>
        </header>

        <div className="grid">
          <article className="card featured">
            <div className="card-top">
              <StarRow />
              <span className="verified">
                <VerifiedBadge size={14} />
                Avis vérifié
              </span>
            </div>
            <blockquote className="quote">
              <span aria-hidden="true" className="open-quote">
                “
              </span>
              {featured.quote}
            </blockquote>
            <p className="context">{featured.context || "Traduit de l'anglais"}</p>
          </article>

          {rest.map((t, i) => (
            <article key={i} className="card">
              <div className="card-top">
                <StarRow />
                <span className="verified" title="Avis vérifié">
                  <VerifiedBadge size={12} />
                  Vérifié
                </span>
              </div>
              <p className="quote">{t.quote}</p>
              <p className="context">{t.context || "Traduit de l'anglais"}</p>
            </article>
          ))}
        </div>

        <a
          className="see-all"
          href={reviewsUrl}
          target="_blank"
          rel="noopener noreferrer"
          hrefLang="en"
        >
          {"Lire plus d'avis clients (en anglais)"}
          <span aria-hidden="true">→</span>
        </a>
      </div>
    </StyledSection>
  );
};
